import styled from 'styled-components'
import { Flex } from 'reflexbox'
import theme from 'styles/theme'
import Button from 'components/Button'

export const Label = styled.label`
  color: ${theme.colors.grays.N500};
  background-color: #fff;
  padding: 0 8px;
  text-transform: uppercase;
  font-size: ${theme.fontSizes.label};
  font-weight: ${theme.fontWeights.extraBold};
  margin-bottom: 8px;
`

export const DropzoneContainer = styled(Flex)`
  border: 1px dashed ${theme.colors.grays.N500};
  border-radius: 8px;
  padding: 64px 0;
  max-width: 280px;
`

export const ClearButton = styled.button`
  border: 0;
  background: transparent;
  cursor: pointer;
`

export const ErrorContainer = styled(Flex)`
  border-radius: 8px;
  background-color: rgba(237, 48, 36, 0.2);
  flex-direction: column;
  padding: 16px;
`

export const FileButton = styled(Button)`
  width: 250px;
`

export const FileLink = styled.a`
  cursor: pointer;
  color: ${theme.colors.turquoises.T300};
`
